import { Shape } from '../types/Shape';
import { getConnectionPoints, getAbsolutePosition } from './connectionUtils';

/**
 * 연결된 화살표의 위치를 업데이트하는 함수
 */
export const updateArrowPosition = (
  arrow: Shape,
  connectedShape: Shape,
  shapeId: string
): Shape => {
  let startX = arrow.x;
  let startY = arrow.y;
  let endX = arrow.x + (arrow.width || 0);
  let endY = arrow.y + (arrow.height || 0);

  if (arrow.startShapeId === shapeId) {
    // 시작점 업데이트
    if (arrow.startConnectionPoint) {
      const connectionPoints = getConnectionPoints(connectedShape);
      const startPoint = connectionPoints[arrow.startConnectionPoint];
      if (startPoint) {
        startX = startPoint.x;
        startY = startPoint.y;
      }
    } else if (arrow.startRelativeX !== undefined && arrow.startRelativeY !== undefined) {
      const absolutePos = getAbsolutePosition(arrow.startRelativeX, arrow.startRelativeY, connectedShape);
      startX = absolutePos.x;
      startY = absolutePos.y;
    }
  }

  if (arrow.endShapeId === shapeId) {
    // 끝점 업데이트
    if (arrow.endConnectionPoint) {
      const connectionPoints = getConnectionPoints(connectedShape);
      const endPoint = connectionPoints[arrow.endConnectionPoint];
      if (endPoint) {
        endX = endPoint.x;
        endY = endPoint.y;
      }
    } else if (arrow.endRelativeX !== undefined && arrow.endRelativeY !== undefined) {
      const absolutePos = getAbsolutePosition(arrow.endRelativeX, arrow.endRelativeY, connectedShape);
      endX = absolutePos.x;
      endY = absolutePos.y;
    }
  }

  return {
    ...arrow,
    x: startX,
    y: startY,
    width: endX - startX,
    height: endY - startY
  };
};

/**
 * 연결 정보를 업데이트하는 함수
 */
export const updateArrowConnections = (
  shapes: Shape[],
  arrowId: string,
  oldStartShapeId: string | undefined,
  oldEndShapeId: string | undefined,
  newStartShapeId: string | undefined,
  newEndShapeId: string | undefined
): Shape[] => {
  const disconnectedShapeIds: string[] = [];
  const connectedShapeIds: string[] = [];

  // 시작점 연결 변경 확인
  if (oldStartShapeId !== newStartShapeId) {
    if (oldStartShapeId) disconnectedShapeIds.push(oldStartShapeId);
    if (newStartShapeId) connectedShapeIds.push(newStartShapeId);
  }

  // 끝점 연결 변경 확인
  if (oldEndShapeId !== newEndShapeId) {
    if (oldEndShapeId) disconnectedShapeIds.push(oldEndShapeId);
    if (newEndShapeId) connectedShapeIds.push(newEndShapeId);
  }

  if (disconnectedShapeIds.length === 0 && connectedShapeIds.length === 0) {
    return shapes;
  }

  return shapes.map(s => {
    // 연결 해제된 객체에서 화살표 제거
    if (disconnectedShapeIds.includes(s.id) && s.connectedArrows) {
      const updatedConnectedArrows = s.connectedArrows.filter(
        id => id !== arrowId
      );

      if (updatedConnectedArrows.length === 0) {
        const { connectedArrows, ...rest } = s;
        return rest as Shape;
      }

      return {
        ...s,
        connectedArrows: updatedConnectedArrows
      };
    }

    // 새로 연결된 객체에 화살표 추가
    if (connectedShapeIds.includes(s.id)) {
      const currentArrows = s.connectedArrows || [];
      if (!currentArrows.includes(arrowId)) {
        return {
          ...s,
          connectedArrows: [...currentArrows, arrowId]
        };
      }
    }

    return s;
  });
};

